/* ============================================================
   CRITERION INDUSTRIES — CAD PAGES (2026)
   - Product-family filter for /pages/cad-library
   - Scroll reveal (same behaviour/timing as the Homepage)
   Vanilla JS, no dependencies. Safe to load on both CAD pages.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Product-family filter (Library page) ---------------- */
  var filterButtons = document.querySelectorAll('.cad-filter-btn');
  var groups = document.querySelectorAll('.cad-group');

  if (filterButtons.length && groups.length) {
    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var family = btn.getAttribute('data-family');

        filterButtons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        groups.forEach(function (group) {
          var match = family === 'all' || group.getAttribute('data-family') === family;
          group.hidden = !match;
        });
      });
    });
  }

  /* ---- Scroll reveal --------------------------------------- */
  var revealEls = document.querySelectorAll('.criterion-cad .reveal');
  if (!revealEls.length) return;

  // Opt into hide-then-animate only now that JS is running.
  document.querySelectorAll('.criterion-cad').forEach(function (el) {
    el.classList.add('js-reveal');
  });

  if (!('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  revealEls.forEach(function (el) { observer.observe(el); });
})();